import React from "react";
import { Link } from "react-router-dom";
import logo from "../images/logo/logo-neurocentro.png";
import { companyName } from "../constants";
import { FacebookIcon, InstagramIcon } from "../icons";

const Footer = () => {
  const socialLinks = [
    {
      name: "Facebook",
      url: "https://www.facebook.com/p/Neurocentro-veterinario-100064009514576/",
      icon: <FacebookIcon fill="white" />,
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/neurocentrovet/",
      icon: <InstagramIcon fill="white" />,
    },
  ];

  const footerSections = [
    {
      title: "Contacto",
      delay: ".4s",
      links: [
        {
          label: "8 Norte 1130, Viña del Mar",
          url: "https://maps.google.com/?q=8+Norte+1130+Viña+del+Mar",
          external: true,
        },
        {
          label: "Teléfono: +56 32 2878437",
          external: true,
        },
        {
          label: "WhatsApp: +56 9 39013512",
          url: "https://wa.me/56939013512?text=Hola,%20quisiera%20solicitar%20información%20por%20favor",
          external: true,
        },
        {
          label: "Email: neurocentroveterinario@gmail.com",
          url: "mailto:neurocentroveterinario@gmail.com",
          external: true,
        },
        {
          label: "Lunes a Viernes 10:00 - 18:00",
          external: true,
        },
        {
          label: "Sábado 09:15 - 16:30",
          external: true,
        },
        {
          label: "Domingo y Feriados 9:30 - 18:30",
          external: true,
        },
      ],
    },
    {
      title: "Mapa",
      delay: ".3s",
      links: [
        { label: "Principal", url: "/" },
        { label: "Neurocentro", url: "/neurocentro" },
        { label: "Consultas", url: "/consultas" },
        { label: "Servicios", url: "/servicios" },
      ],
    },
  ];

  // Calculate dynamic width classes based on number of sections
  const getSectionWidth = () => {
    const count = footerSections.length;
    // Map section count to Tailwind classes (ensures JIT compiler can detect them)
    const widthMap = {
      1: "w-full px-4 sm:w-1/2 md:w-full lg:w-full",
      2: "w-full px-4 sm:w-1/2 md:w-6/12 lg:w-6/12",
      3: "w-full px-4 sm:w-1/2 md:w-4/12 lg:w-4/12",
      4: "w-full px-4 sm:w-1/2 md:w-3/12 lg:w-3/12",
      5: "w-full px-4 sm:w-1/2 md:w-2/12 lg:w-2/12",
      6: "w-full px-4 sm:w-1/2 md:w-2/12 lg:w-2/12",
    };
    return widthMap[count] || "w-full px-4 sm:w-1/2 md:w-3/12 lg:w-3/12";
  };

  return (
    <footer>
      <div className="bg-[#F8FAFB] pt-[95px] pb-[46px] dark:bg-[#15182A]">
        <div className="container max-w-[1390px]">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full px-4 lg:w-4/12 xl:w-5/12">
              <div
                className="wow fadeInUp mb-11 max-w-[320px]"
                data-wow-delay=".2s"
              >
                <Link to="/" className="inline-block mb-8">
                  <img
                    src={logo}
                    alt="logo"
                    className="block max-w-full dark:hidden"
                  />
                  <img
                    src={logo}
                    alt="logo"
                    className="hidden max-w-full dark:block"
                  />
                </Link>
                <p className="text-base text-body">
                  {companyName} - Cuidando la salud neurológica de tus mascotas
                </p>
              </div>
            </div>

            <div className="w-full px-4 lg:w-8/12 xl:w-7/12">
              <div className="flex flex-wrap -mx-4">
                {footerSections.map((section) => (
                  <div key={section.title} className={getSectionWidth()}>
                    <div
                      className="wow fadeInUp mb-11"
                      data-wow-delay={section.delay}
                    >
                      <h3 className="mb-8 text-[22px] font-medium text-black dark:text-white">
                        {section.title}
                      </h3>
                      <ul className="space-y-[10px]">
                        {section.links.map((link) => (
                          <li key={link.label}>
                            {link.external ? (
                              <a
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block text-base text-body hover:text-primary"
                              >
                                {link.label}
                              </a>
                            ) : (
                              <Link
                                to={link.url}
                                className="inline-block text-base text-body hover:text-primary"
                              >
                                {link.label}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="wow fadeInUp bg-primary py-7 dark:bg-black"
        data-wow-delay=".2s"
      >
        <div className="container max-w-[1390px]">
          <div className="flex flex-wrap -mx-3">
            <div className="order-last w-full px-3 lg:order-first lg:w-1/3">
              <p className="mt-4 text-base text-center text-white lg:mt-0 lg:text-left">
                &copy; 2025 {companyName}. Todos los derechos reservados
              </p>
            </div>

            <div className="w-full px-3 md:w-1/2 lg:w-1/3">
              <div className="flex items-center justify-center mb-4 space-x-5 md:mb-0 md:justify-start lg:justify-center">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white opacity-70 hover:opacity-100"
                    aria-label={social.name}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            <div className="w-full px-3 md:w-1/2 lg:w-1/3">
              <div className="flex items-center justify-center space-x-4 sm:space-x-8 md:justify-end lg:justify-end">
                <a href="#" className="text-base text-white">
                  Política de Privacidad
                </a>
                <a href="#" className="text-base text-white">
                  Términos y Condiciones
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
